import React, { useEffect, useState } from "react";
import { TicketIcon, BranchUserIcon, DownloadIcon } from "../../assets";
import { IconPrimary } from "../../components";
import { Col, Row } from "antd";
import axiosClient from "../../api/axiosClient";
import LogsTable from "./LogsTable";
import downloadDataIExcelSheet from "../../utils/downloadDataIExcelSheet";
import useUser from "../../hooks/useUser";

interface ILogsTypes {
  name: string;
  endpoint: string;
  Icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
}
export default function ATCLogs() {
  const logs: ILogsTypes[] = [
    { name: "Student Logs", Icon: BranchUserIcon, endpoint: "user" },
    { name: "Voucher Logs", Icon: TicketIcon, endpoint: "voucher" },
  ];

  const [data, setData] = useState<any>([]);

  const [active, setActive] = useState(logs[0]);

  const { user } = useUser();

  useEffect(() => {
    setData([]);
    axiosClient
      .get(`/logs/atc/${user?.atc.id}/${active.endpoint}`)
      .then((res) => setData(res.data))
      .catch(() => {});
  }, [active, user]);

  const isHaveEditPermission = user?.permissions?.includes("atc.edit");

  return (
    <>
      <Row>
        <Col flex={1}>
          <div className="logs_title">
            <h4>{active.name}</h4>
          </div>
        </Col>

        <Row gutter={[10, 10]}>
          <Col>
            <IconPrimary
              disabled={!isHaveEditPermission}
              onClick={() =>
                downloadDataIExcelSheet(data, `${active?.name}_logs`)
              }
            >
              <DownloadIcon />
            </IconPrimary>
          </Col>
          {logs.map((log: ILogsTypes, index: number) => {
            const Icon = log.Icon;
            return (
              <Col onClick={() => setActive(log)} key={index}>
                <div className={active.name === log.name ? "logs_active" : ""}>
                  <IconPrimary>
                    <Icon />
                  </IconPrimary>
                </div>
              </Col>
            );
          })}
        </Row>
      </Row>

      <LogsTable logs={data} loading={false} />
    </>
  );
}
